<template>
    <div v-if="access.read === 1">
    <app-toolbarcustom app_title="Kalkulator Profitabilitas" app_menu="bot"></app-toolbarcustom>
        <template>
            <v-stepper v-model="steppers" class="mt-15 elevation-0">
              <v-stepper-header>
                <v-stepper-step
                  :complete="steppers > 1"
                  step="1"
                >
                  Form
                </v-stepper-step>
          
                <v-divider></v-divider>
          
                <v-stepper-step
                  :complete="steppers > 2"
                  step="2"
                >
                  Summary
                </v-stepper-step>
                
              </v-stepper-header>
          
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card
                    class="mb-12 elevation-0"
                  >
                  <v-form enctype="multipart/form-data" ref="form_medical_data" lazy-validation>
                  <v-row>
                        <v-col cols="12" sm="12" md="12" class="mt-2">
                        <app-number
                            v-model         ="form.calculate_ijprate"
                            label           ="IJP Rate Year(%)"
                            placeholder     ="IJP Rate Year(%)"
                            backgroundColor ="numeric"
                            :decimal         ="2"
                            required
                            solo-inverted
                            outlined
                        >
                        </app-number>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <app-number
                                v-model         ="form.calculate_lossratio"
                                label           ="Loss Ratio(%)"
                                placeholder     ="Loss Ratio(%)"
                                backgroundColor ="numeric"
                                :decimal         ="2"
                                required
                                solo-inverted
                                outlined
                            >
                            </app-number>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <app-number
                                v-model         ="form.calculate_acqfee"
                                label           ="Acquisition Fee(%)"
                                placeholder     ="Acquisition Fee(%)"
                                backgroundColor ="numeric"
                                :decimal         ="2"
                                required
                                solo-inverted
                                outlined
                            >
                            </app-number>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <app-number
                                v-model         ="form.calculate_reference"
                                label           ="Net Margin Acuan(%)"
                                placeholder     ="Net Margin Acuan(%)"
                                backgroundColor ="readonly"
                                :decimal         ="2"
                                :readonly       ="true"
                                required
                                solo-inverted
                                outlined
                            >
                            </app-number>
                        </v-col>
                        <!-- <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <app-number
                                v-model         ="form.calculate_netmargin"
                                label           ="Net Margin(%)"
                                placeholder     ="Net Margin(%)"
                                backgroundColor ="readonly"
                                :decimal         ="5"
                                :readonly       ="true"
                                required
                                solo-inverted
                                outlined
                            >
                            </app-number>
                        </v-col> -->
                    </v-row> 
                    </v-form>
                  </v-card>
                  <v-btn
                    color="primary"
                    @click="NextStep(1)"
                    block
                  >
                    Hitung
                  </v-btn>
          
                </v-stepper-content>
          
                <v-stepper-content step="2">
                  <v-card
                    class="mb-12"
                    outlined
                  >
                  <v-card-title class="body-2 font-weight-bold">Ringkasan</v-card-title>

                    <v-card-text class="caption">
                            <v-row align="center">
                                <v-col cols="6">Net Margin Acuan</v-col><v-col cols="6" class="font-weight-bold">{{ $functions.NewFormatNumber(form.calculate_reference,2) }}%</v-col>
                                <v-col cols="6" class="mt-n5">Net Margin Kalkulasi</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ $functions.NewFormatNumber(form.calculate_netmargin,2) }}%</v-col>
                                <v-col cols="6" class="mt-n5 body-1 font-weight-bold">Kesimpulan</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold body-1">
                                    <span class="green--text" v-if="form.calculate_netmargin.toFixed(2) >= form.calculate_reference.toFixed(2)">Profitable</span>
                                    <span class="red--text" v-else>Tidak Profitable</span>
                                </v-col>
                                <v-col cols="12">
                                    <template>
                                        <v-simple-table dense>
                                          <template v-slot:default>
                                            <thead>
                                              <tr>
                                                <th class="text-center">
                                                  Jangka Waktu Tahun
                                                </th>
                                                <th class="text-center">
                                                    Rate IJP(%)
                                                  </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr
                                                v-for="rows in 15"
                                                :key="rows"
                                              >
                                                <td class="text-center"><span v-if="rows > 1">></span>{{ rows - 1 }} - {{ rows }}</td>
                                                <td class="text-right">{{ $functions.NewFormatNumber(form.calculate_ijprate * rows,2) }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </template>
                                </v-col>
                                <v-col cols="12">
                                    <template>
                                        <v-simple-table dense>
                                          <template v-slot:default>
                                            <thead>
                                              <tr>
                                                <th class="text-center">
                                                  Jangka Waktu Bulan
                                                </th>
                                                <th class="text-center">
                                                    Rate IJP(%)
                                                  </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr
                                                v-for="row in 4"
                                                :key="row"
                                              >
                                                <td class="text-center">
                                                    <span> <span v-if="row > 1"> > </span>{{ (row - 1) * 3 }} - {{ row * 3 }}</span>
                                                </td>
                                                <td class="text-right">{{ $functions.NewFormatNumber(form.calculate_ijprate * (row * 3)/12,2) }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </template>
                                </v-col>
                            </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                 </v-card>
                  <v-btn color="secondary" @click="steppers = 1" block>
                    Sebelumnya
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
          <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            steppers: 1,
            url_type: 'add',
            current_date: '',
            form: {
                calculate_ijprate: 0,
                calculate_lossratio: 0,
                calculate_acqfee: 0,
                calculate_netmargin: 0,
                calculate_reference: 0.14,
            },
            loading: {
                upload: false
            },
            upload: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                upload: 'Upload',
                delete: 'Hapus',
                src: '',
                target: '',
            },
            access: {
                read: 0
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
            format_amount: {
                locale: "id-ID",
                prefix: "",
                suffix: "",
                length: 15,
                precision: 2
            },
            // Format Properties
            properties: {
                reverse: true,
                'prepend-icon':'money'
            },
        }),
        created(){
          this.Access()
        },
        methods: {
            GoTo (url) {
               this.$router.push(url)
            },
            Access () {
                let modul = 'calculatepl'
                let formdata = {
                    menu_id: modul,
                    users_id: this.$functions.UsersID(),
                    order_by: 'menu_id',
                    order_type: 'ASC',
                    flag: 'mobileapp',
                    limit: this.limit,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListMenuUser'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let priv = response.data
                    if (priv.length > 0) {
                        if (priv[0].feedback !== 'Y') {
                            this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                        } else {
                        	if (priv[0].usersmenu_read === 0) {
                                let url = 'home'
                                this.$router.push({name: url})
                            } else {
                                this.access.read  	= priv[0].usersmenu_read
                            }
                        }
                    } else {
                      let url = 'bot'
                      this.$router.push({name: url})
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 0)
                })
            },
            GetTotal() {
                // Pastikan nilai dikonversi ke angka untuk menghindari NaN
                let ijprate = Number(this.form.calculate_ijprate) || 0;
                let lossratio = Number(this.form.calculate_lossratio) || 0;
                let acqfee = Number(this.form.calculate_acqfee) || 0;

                // Validasi jika ada nilai yang kosong
                if (isNaN(ijprate) || isNaN(lossratio) || isNaN(acqfee)) {
                    this.SnackBar(true, 'error', 'Mohon isi semua nilai dengan benar', 3000);
                    return;
                }

                // Pastikan nilai masuk akal
                if (ijprate < 0 || lossratio < 0 || acqfee < 0) {
                    this.SnackBar(true, 'error', 'Nilai tidak boleh negatif', 3000);
                    return;
                }

                // Hitung net margin
                let total = (ijprate * ((100 - lossratio) - acqfee)) / 100;

                // Update hasil ke form
                this.form.calculate_netmargin = total;
            },
            NextStep(id) {
                this.GetTotal()
                if (this.form.calculate_netmargin > 0) {
                  if (id === 1) {
                      let validation = ''
                      if (this.form.calculate_ijprate === 0) {
                          validation = 'Mohon isi IJP Rate'
                      } else if (this.form.calculate_lossratio === '') {
                          validation = 'Mohon isi Loss Ratio'
                      } else if (this.form.calculate_acqfee === 0) {
                          validation = 'Mohon isi Acquisition Fee'
                      } else if (this.form.calculate_netmargin === 0) {
                          validation = 'Net Margin TIdak Boleh 0'
                      }
                      if (validation !== '') {
                          this.SnackBar(true, 'error', validation, 0)
                      } else {
                          this.steppers = 2
                      }
                  }
                } else {
                  this.SnackBar(true, 'error', 'Net Margin tidak boleh 0', 0)
                }
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>